import { get } from "lodash";
import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { NavLink } from "react-router-dom";

import {
  RESOURCE_AT_TYPES,
  RESOURCE_URI_CHUNKS
} from "../../constants/entity.js";

class EntityLink extends PureComponent {
  static propTypes = {
    entity: PropTypes.object.isRequired,
    linkText: PropTypes.string
  };

  getEntityUrl() {
    const { entity } = this.props;
    if (RESOURCE_AT_TYPES.find(type => type === entity["@type"])) {
      return `/${RESOURCE_URI_CHUNKS.RESOURCES}${entity["@id"]}`;
    }
    return entity["@id"] || "";
  }

  getLinkContent() {
    const { children, entity, linkText } = this.props;

    if (linkText) return linkText;

    if (!children) {
      return `${get(entity, "name", "")}`;
    }

    return children;
  }

  render() {
    const { style } = this.props;

    return (
      <NavLink to={this.getEntityUrl()} style={style}>
        {this.getLinkContent()}
      </NavLink>
    );
  }
}

export default EntityLink;
